import type { CryptoUtils } from './CryptoUtils';

export function hashOtpCode(crypto: CryptoUtils, verificationId: string, otpCode: string, secret: string) {
    return crypto.createSHA256Hash(`${verificationId}:${secret}:${otpCode}`, 'hex');
}

export function verifyOtpCode(
    crypto: CryptoUtils,
    verificationId: string,
    otpCode: string,
    secret: string,
    targetHash: string,
): boolean {
    return crypto.timingSafeEqual(hashOtpCode(crypto, verificationId, otpCode, secret), targetHash);
}
